module.exports = __webpack_public_path__ + "static/media/phoneDesign.57cc34d6.png";